import * as vehAudit from './vehAudit';

const reducers = {
  ...vehAudit,
};

export default reducers;

